import {
  FETCH_FRIENDS_INFO,
  FETCH_FRIENDS_INFO_SUCCESS,
  FETCH_FRIENDS_INFO_FAILED,
  ADD_FRIEND,
  RESET,
  DELETE_ADD_FRIEND,
  DELETE_ADD_FRIEND_FETCH,
  ADD_FRIEND_FETCH,
  ACCEPT_ADD_FRIEND,
  DELETE_FRIEND,
  ACCEPT_ADD_FRIEND_FETCH,
  DELETE_FRIEND_FETCH
} from "../actions/types";

interface FriendsInfo {
  friend_requests_received: {
    count: number;
    data: { [key: string]: string };
  };
  friend_requests_sent: {
    count: number;
    data: { [key: string]: string };
  };
  friends: {
    count: number;
    data: { [key: string]: string };
  };
}

export interface friendActionInterface {
  type: string;
  payload?: FriendsInfo;
}

export interface FriendsInterface {
  errorFetching: string;
  loading: boolean;
  adding_friend: boolean;
  deleting_friend_request: boolean;
  accepting_friend: boolean;
  deleting_friend: boolean;
  info?: FriendsInfo;
}

const INITIAL_STATE: FriendsInterface = {
  errorFetching: "",
  loading: false,
  adding_friend: false,
  deleting_friend_request: false,
  accepting_friend: false,
  deleting_friend: false,
  info: undefined
};

const friends = (
  state: FriendsInterface = INITIAL_STATE,
  action: friendActionInterface
): FriendsInterface => {
  switch (action.type) {
    case FETCH_FRIENDS_INFO:
      return {
        ...state,
        loading: true
      };
    case FETCH_FRIENDS_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        info: action.payload
      };
    case FETCH_FRIENDS_INFO_FAILED:
      return {
        ...state,
        loading: false,
        info: undefined
      };
    case DELETE_ADD_FRIEND:
      return {
        ...state,
        deleting_friend_request: true
      };
    case DELETE_ADD_FRIEND_FETCH:
      return {
        ...state,
        deleting_friend_request: false
      };

    case ADD_FRIEND:
      return {
        ...state,
        adding_friend: true
      };
    case ADD_FRIEND_FETCH:
      return {
        ...state,
        adding_friend: false
      };

    case ACCEPT_ADD_FRIEND:
      return {
        ...state,
        accepting_friend: true
      };
    case ACCEPT_ADD_FRIEND_FETCH:
      return {
        ...state,
        accepting_friend: false
      };

    case DELETE_FRIEND:
      return {
        ...state,
        deleting_friend: true
      };
    case DELETE_FRIEND_FETCH:
      return {
        ...state,
        deleting_friend: false
      };
    case RESET:
      return {
        ...state,
        loading: false,
        info: undefined
      };

    default:
      return state;
  }
};

export default friends;
